// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const StrikethroughSIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="StrikethroughSIcon" ref={forwardedRef} {...props}>
      <path d="M6.721 13.698 5.938 15.02c.967.91 2.408 1.485 4.052 1.485 2.544 0 4.072-1.399 4.072-3.67 0-.694-.141-1.31-.422-1.83h-2.421c.937.367 1.373 1.056 1.373 1.917 0 1.217-.88 2.079-2.553 2.079-1.306 0-2.39-.566-3.318-1.303" />
      <path d="M6.418 8.003h1.61a2 2 0 0 1-.243-.992c0-1.111.774-2.002 2.438-2.002 1.112 0 2.166.402 3.017.872l.464-1.485c-.996-.585-2.302-.891-3.598-.891-2.456 0-3.791 1.236-3.791 3.487q0 .545.103 1.011" />
      <path d="M16.25 11.005H3.75v-1.5h12.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const StrikethroughSIcon = /* @__PURE__ */ Object.assign(
  StrikethroughSIconComponent,
  { displayName: 'StrikethroughSIcon' },
);
